import { createFileRoute, Link } from "@tanstack/react-router";
import { buildBreadcrumbs } from "@/components/SchemaJsonLd";
import { PageHero } from "@/components/PageHero";
import { CTASection } from "@/components/CTASection";
import { SectionHeading } from "@/components/SectionHeading";
import { ArrowRight } from "lucide-react";
import heroImg from "@/assets/hero-garage.jpg";

const POSTS = [
  { slug: "best-garage-floor-coatings", title: "The Best Garage Floor Coatings of 2026", desc: "Our ranked guide to the floor coating systems that actually last.", date: "Mar 12, 2026" },
  { slug: "metallic-epoxy-design-ideas", title: "10 Metallic Epoxy Design Ideas for Custom Garages", desc: "Color palettes and pattern direction for your next floor.", date: "Feb 28, 2026" },
  { slug: "garage-renovation-tips", title: "Garage Renovation Tips From Calgary Region Pros", desc: "Storage, lighting, and flooring decisions that pay off long-term.", date: "Feb 14, 2026" },
  { slug: "commercial-floor-coating-solutions", title: "Commercial Floor Coating Solutions", desc: "Choosing the right system for warehouses, breweries, and retail.", date: "Jan 30, 2026" },
  { slug: "concrete-coating-maintenance", title: "Long-Term Concrete Coating Maintenance", desc: "Simple care that keeps a coated floor looking new for 15+ years.", date: "Jan 16, 2026" },
];

export const Route = createFileRoute("/blog/")({
  head: () => ({
    meta: [
      { title: "Garage Floor Coating Blog | MLC Epoxy Floors" },
      { name: "description", content: "Articles on garage floor coatings, epoxy systems, polyaspartic technology, and concrete maintenance from the Calgary region's coating specialists." },
      { property: "og:title", content: "Blog | MLC Epoxy Floors" },
      { property: "og:description", content: "Expert articles on garage floor coatings, epoxy, polyaspartic, and concrete care." },
      { property: "og:url", content: "/blog" },
    ],
    links: [{ rel: "canonical", href: "/blog" }],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(buildBreadcrumbs([
        { name: "Home", href: "/" },
        { name: "Blog", href: "/blog" },
      ])) },
    ],
  }),
  component: () => (
    <>
      <PageHero eyebrow="Blog" title="Garage Floor Coating Insights" body="Articles, design ideas, and expert advice from the Calgary region's premier coating specialists." image={heroImg} />
      <section className="container-x py-20">
        <SectionHeading eyebrow="Latest" title="Recent Articles" />
        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {POSTS.map((p) => (
            <Link key={p.slug} to={`/blog/${p.slug}` as string} className="group rounded-sm border border-border bg-charcoal p-7 hover:border-copper">
              <p className="text-xs uppercase tracking-widest text-copper">{p.date}</p>
              <p className="mt-3 text-xl text-silver-light group-hover:text-copper">{p.title}</p>
              <p className="mt-2 text-silver">{p.desc}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wider text-copper">Read <ArrowRight className="h-3.5 w-3.5" /></span>
            </Link>
          ))}
        </div>
      </section>
      <CTASection />
    </>
  ),
});
